<template>
	<v-container grid-list-xl class="container--box">
		<v-layout row wrap>
			<v-flex xs12 class="my-10">
				<h2 class="white--text">Hi, How do you want to make order?</h2>
			</v-flex>
			<v-flex xs12 md6>
				<Link
					as="v-card"
					class="text-center"
					link
					:href="$route('shop.delivery.address')"
				>
					<v-card-title>
						<v-spacer></v-spacer>
						<v-avatar color="secondary" size="150">
							<v-icon size="120" dark>mdi-moped</v-icon>
						</v-avatar>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-title primary-title class="text-center">
						<v-spacer></v-spacer>
						Order for delivery
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-text>
						Receive your order with 30mins or your money back.
					</v-card-text>
				</Link>
			</v-flex>
			<v-flex xs12 md6>
				<Link
					as="v-card"
					class="text-center"
					link
					:href="
						$route('shop.pickup.tenants', {
							'filter[pickup_module]': true,
						})
					"
				>
					<v-card-title>
						<v-spacer></v-spacer>
						<v-avatar color="secondary" size="150">
							<v-icon size="120" dark>mdi-package</v-icon>
						</v-avatar>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-title primary-title class="text-center">
						<v-spacer></v-spacer>
						Order and pickup
						<v-spacer></v-spacer>
					</v-card-title>
					<v-card-text>
						Pickup your order at our counter within 10mins.
					</v-card-text>
				</Link>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
};
</script>